import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="w-full px-4 md:px-8 pt-8 pb-4 bg-background-50">
      <div className="max-w-7xl mx-auto bg-secondary-50 rounded-3xl px-6 md:px-12 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-3">
              <span className="font-heading text-2xl font-bold text-accent-500 tracking-tight">
                ItaoBuy
              </span>
            </Link>
            <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
              La piattaforma di riferimento in Italia per guide, template e strumenti dedicati a ItaoBuy Spreadsheet. Organizza prodotti, prezzi e ordini con efficienza professionale.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">
              Navigazione
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/articoli/guida-completa-itaobuy-spreadsheet" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  Guida ItaoBuy
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  itaobuy sheet
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">
              Risorse
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  ItaoBuy Spreadsheet Italia
                </Link>
              </li>
              <li>
                <Link to="/articoli/guida-completa-itaobuy-spreadsheet" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  Template e Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  Sito Principale
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">
              Collegamenti
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  Home Page
                </Link>
              </li>
              <li>
                <Link to="/articoli/guida-completa-itaobuy-spreadsheet" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  Articoli SEO
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap">
                  buy it now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span>&copy; {new Date().getFullYear()} ItaoBuy Spreadsheet</span>
              <span className="hidden sm:inline">|</span>
              <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">Privacy</Link>
              <span>|</span>
              <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">Termini</Link>
              <span>|</span>
              <Link to="/" className="hover:text-accent-500 transition-colors cursor-pointer">Cookie</Link>
            </div>
            <div className="flex items-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="X / Twitter"
              >
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-accent-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}